<template>
  <IQOS required :title="$t('marketplace.balance_title')">
    <div class="cards-container gap-column-sm mt-16">
      <div class="balance-badge-container w-100">
        <div
          :class="{
            'balance-badge': true,
            red: billing_account.balance < 0,
            'qrw-heading-xl': true
          }"
        >
          {{ billing_account.balance }}
          <span class="balance-currency">
            ₴
          </span>
        </div>
      </div>
      <div class="gap-row-xs w-100">
        <BaseButton
            variant="secondary"
            color="v1-grey-10"
            size="md"
            @click="$router.push('/table/marketplace')"
          >
            {{ $t("tables.orders_history") }}
          </BaseButton>
          <BaseButton
            variant="primary"
            color="green-6"
            size="md"
            @click="deposit_modal = true"
          >
            {{ $t("marketplace.add_balance") }}
          </BaseButton>
          
        </div>
    </div>

    <DepositModal @close="deposit_modal = false" v-if="deposit_modal" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import DepositModal from "@/components/billing/DepositModal.vue";

import BillingAPI from "@/api/billing";

export default {
  data() {
    return {
      deposit_modal: false,
      reminder_threshold: 0,
    };
  },
  components: {
    IQOS,
    DepositModal,
  },
  methods: {
    updateBillingAccount() {
      if (isNaN(this.reminder_threshold)) return;

      BillingAPI.updateReminderSettings(Math.round(this.reminder_threshold))
        .then((data) => {
          this.$store.commit("setBillingAccount", data.account);
        })
        .catch((error) => {
          this.$store.dispatch("showError", "billing_fetch");
        });
    },
  },
  mounted() {
    if (this.billing_account.reminder_threshold) {
      this.reminder_threshold = this.billing_account.reminder_threshold;
    }
  },
  computed: {
    billing_account() {
      return this.$store.state.billing_account;
    },
  },
};
</script>

<style scoped>
.balance-badge-container {
  padding: 8px 0;
  border-radius: 4px;
  width: 100%;
  border: 1px solid var(--green-5-color);
  color: var(--green-5-color);
  
  display: flex;
  justify-content: center;
  align-items: center;
}

.red {
  border-color: var(--red-4-color);
  color: var(--red-4-color);
}
</style>